const DEFAULT_THEME = {
  typography: {
    fontFamily: [
      "Noto Sans TC",
      " sans-serif",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  primary: "#6d6c68",
  text: "#252525",
  white: "#fff",
  disable: "#efefef",
  black: "#000",
};

export default DEFAULT_THEME;
